import { render } from "./UsageDashboard.vue?vue&type=template&id=2a6ea16c&scoped=true"
import script from "./UsageDashboard.vue?vue&type=script&lang=js"
export * from "./UsageDashboard.vue?vue&type=script&lang=js"

import "./UsageDashboard.vue?vue&type=style&index=0&id=2a6ea16c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6ea16c"]])

export default __exports__